import { z } from 'zod';
import type { AISchemaField, UISchemaField } from '../types/index';

export const howItWorksAISchema: AISchemaField[] = [
  { name: 'eyebrow', type: 'string', required: false, max: 30 },
  { name: 'headline', type: 'string', required: true, max: 80 },
  { name: 'subheadline', type: 'string', required: false, max: 200 },
  {
    name: 'steps',
    type: 'array<object>',
    required: true,
    fields: [
      { name: 'title', type: 'string', required: true, max: 50 },
      { name: 'description', type: 'string', required: true, max: 200 },
      { name: 'image', type: 'image_url', required: false },
    ],
  },
];

export const howItWorksUISchema: UISchemaField[] = [
  { name: 'eyebrow', type: 'text', label: 'Eyebrow', max: 30 },
  { name: 'headline', type: 'text', label: 'Headline', required: true, max: 80 },
  { name: 'subheadline', type: 'textarea', label: 'Subheadline', max: 200 },
  { name: 'steps', type: 'step_list', label: 'Steps', required: true },
];

export const howItWorksZodSchema = z.object({
  eyebrow: z.string().max(30).optional().nullable(),
  headline: z.string().min(1).max(80),
  subheadline: z.string().max(200).optional().nullable(),
  steps: z
    .array(
      z.object({
        title: z.string().max(50),
        description: z.string().max(200),
        image: z.string().optional().nullable(),
      }),
    )
    .min(2)
    .max(6),
});

export type HowItWorksContent = z.infer<typeof howItWorksZodSchema>;

export const howItWorksSample: HowItWorksContent = {
  eyebrow: 'How it works',
  headline: 'From idea to live in three steps.',
  subheadline: 'No infrastructure to set up. No code to maintain.',
  steps: [
    {
      title: 'Start with a prompt',
      description: 'Describe what you want. Our system picks the right structure.',
      image: null,
    },
    {
      title: 'Customize live',
      description: 'Edit each section in place. See changes update instantly.',
      image: null,
    },
    {
      title: 'Publish anywhere',
      description: 'One-click publish to your domain. SEO and OG tags included.',
      image: null,
    },
  ],
};
